"use server";

import {
  addVehicleBrandSchema,
  editVehicleBrandSchema,
  deleteVehicleBrandSchema,
} from "@/lib/schemas/vehicle-brands";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { requireServerRole } from "@/lib/guards";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteVehicleBrand(
  params: z.infer<typeof deleteVehicleBrandSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteVehicleBrandSchema, params);

    await prisma.vehicleBrand.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addVehicleBrand(
  params: z.infer<typeof addVehicleBrandSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name } = validateParams(addVehicleBrandSchema, params);

    const vehicleBrand = await prisma.vehicleBrand.create({
      data: { name, isActive: true },
    });

    return { success: true, data: vehicleBrand };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editVehicleBrand(
  params: z.infer<typeof editVehicleBrandSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      isActive = true,
    } = validateParams(editVehicleBrandSchema, params);

    const vehicleBrand = await prisma.vehicleBrand.update({
      where: { id },
      data: { name, isActive },
    });

    return { success: true, data: vehicleBrand };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
